/* ax-dealbar.js - rotating deals bar of speclang.pro and app / fact / form .speclang.pro (owner 2026-10-08), since round E (2026-10-10) also of axtlan.mx,
   studio.olmteka.com and shop.axtlan.mx (same file everywhere; the host's colours are in its ax-settings.css). Needs ax-core.js; data = settings.dealbar.
   Axtlan: today's offers of shop.axtlan.mx read from the shop's live collections (featured of the day, faction of the week, album of the month,
   and the holiday deal on a civic holiday) through /collections/<handle>/products.json, exactly like axtlan.mx; percents = the shop's automatic
   discounts. Speclang: service of the day and collection of the week from the shared rotation (tienda-rotation.json, the file speclang.pro uses).
   One offer at a time, every 5 s; pauses on hover and keyboard focus. With reduced motion (and the site's light / low / high-contrast modes)
   the bar does not rotate: it shows the same one-offer line and the dots switch offers by hand (class is-static).
   Round E (owner 2026-10-10): offers never overlap or get cut - fit() drops the countdown and title, then the label (and, while rotating, the
   dots), then the name (classes ax-fit-1/2/3, same order as the narrow-screen rules of ax-dealbar.css) until every offer fits the bar's line.
   Without JS or network the static offers stay (labels, percents, links to the collections). Visual only: no storage. */
(() => {
  "use strict";
  const C = window.AxCore; const bar = document.querySelector("[data-ax-dealbar]");
  if (!C || !bar) return;
  const D = C.S.dealbar || {}; const S = D.strings || {}; const AX = D.axtlan || {}; const SP = D.speclang || {};
  const list = bar.querySelector(".ax-dealbar__list"); const dots = bar.querySelector(".ax-dealbar__dots");
  const link = (base, path, utm) => utm ? `${base}${path}${path.includes("?") ? "&" : "?"}${utm}` : `${base}${path}`;   // no utm on the shop's own pages
  const motion = matchMedia("(prefers-reduced-motion: reduce)");
  const forced = matchMedia("(forced-colors: active)");
  const reduced = () => motion.matches || forced.matches || [document.documentElement, document.body].some(el =>
    el && (el.dataset.motionAllowed === "false" || ["off", "reduce"].includes(el.dataset.motion) ||
      ["off", "low", "light"].includes(el.dataset.mode) || el.dataset.contrast === "high"));
  const bin = (s) => D.binary ? [...new TextEncoder().encode(s)].map((b) => b.toString(2).padStart(8, "0")).join(" ") : s;   // Binary edition (zxx): live names in bits like the rest of the page
  let fitQueued = 0;
  const queueFit = () => { if (!fitQueued) fitQueued = requestAnimationFrame(() => { fitQueued = 0; fit(); }); };
  const setItem = (li, name, href) => { if (!li) return; if (name) li.querySelector(".ax-dealbar__name").textContent = name; if (href) li.querySelector("a").href = href; queueFit(); };
  const hol = C.todayKey && C.info(C.todayKey).name;
  if (hol) {
    const li = document.createElement("li");
    li.className = "ax-dealbar__item"; li.dataset.shop = "axtlan"; li.dataset.collection = "holiday-deal";
    li.innerHTML = `<a href="${C.esc(link(AX.shopBase, "/collections/holiday-deal", AX.utm))}" target="_blank" rel="noopener"><b class="ax-dealbar__shop">Axtlan</b>`
      + `<span class="ax-dealbar__label">${C.esc(hol)}</span><span class="ax-dealbar__name" data-ax-truncate></span><b class="ax-dealbar__pct">\u2212${C.esc(String((AX.deals || {}).holiday || ""))}%</b>`
      + `<time data-ax-ends></time><span class="ax-dealbar__arrow" aria-hidden="true">\u2197</span></a>`;
    list.prepend(li);
  }
  // Each request gets its own time limit, so a slow server relay never uses up the time of the direct fallback.
  const timed = (url, ms) => {
    const controller = typeof AbortController === "function" ? new AbortController() : null;
    const timer = controller && setTimeout(() => controller.abort(), ms);
    return fetch(url, { credentials: "omit", ...(controller ? {signal: controller.signal} : {}) }).finally(() => { if (timer) clearTimeout(timer); });
  };
  // Format suffix of the shop's product titles in every shop language (read from shop.axtlan.mx/<locale>/products.json, 2026-10-10).
  const FORMAT = /\s+-\s+(Digital Download|Digital Album|Descarga digital|Álbum digital|Download digital|数字下载|数字专辑|تنزيل رقمي|ألبوم رقمي|Digitaler Download|Digitales Album|Ψηφιακή λήψη|Ψηφιακό άλμπουμ|دانلود دیجیتال|آلبوم دیجیتال|Téléchargement numérique|Album numérique|डिजिटल डाउनलोड|डिजिटल एल्बम|Digitális letöltés|Digitális album|Unduhan Digital|Album Digital|デジタルダウンロード|デジタルアルバム|디지털 다운로드|디지털 앨범|цифровая загрузка|цифровой альбом|டிஜிட்டல் பதிவிறக்கம்|டிஜிட்டல் ஆல்பம்|ดาวน์โหลดดิจิทัล|อัลบั้มดิจิทัล|Dijital İndirme|Dijital Albüm|ڈیجیٹل ڈاؤن لوڈ|ڈیجیٹل البم|Tải xuống kỹ thuật số|Album kỹ thuật số)\s*$/i;
  const axFill = async (li) => {
    try {
      const locale = new URL(AX.shopBase).pathname.replace(/^\/|\/$/g, "");
      const query = new URLSearchParams({ locale, collection: li.dataset.collection });
      // Shopify throttles the server relay (429 on shared hosting, measured 2026-10-10), so the shop's public JSON (CORS *, allowed by
      // the CSP) is asked first; the relay is only the fallback when the browser cannot reach the shop.
      let r = await timed(new URL(`collections/${encodeURIComponent(li.dataset.collection)}/products.json?limit=1`, AX.shopBase.replace(/\/?$/, "/")), 6000).catch(() => null);
      const relay = AX.relay === undefined ? "/axtlan-offers.php" : AX.relay;   // "" = no relay (shop.axtlan.mx itself)
      if ((!r || !r.ok) && relay) r = await timed(`${relay}?${query}`, 4000);
      if (!r || !r.ok) return;
      const p = (await r.json()).products?.[0];
      if (p && typeof p.title === "string" && typeof p.handle === "string" && /^[a-z0-9][a-z0-9-]{0,199}$/.test(p.handle)) setItem(li, bin(p.title.replace(FORMAT, "").replace(/^Axtlan\s+/i, "")), link(AX.shopBase, `/products/${p.handle}`, AX.utm));
    } catch { /* keep the static offer */ }
  };
  const spFill = async () => {
    try {
      const r = await fetch(SP.rotationUrl, { credentials: "omit", cache: "no-cache" });
      if (!r.ok) return;
      const R = await r.json(); const t = C.today;
      const row = R.by_mmdd && (R.by_mmdd[C.pad(t.month) + C.pad(t.day)] || (t.month === 2 && t.day === 29 ? R.by_mmdd["0228"] : null));
      if (!row) return;
      if (row.featured_handle) setItem(list.querySelector('[data-shop="speclang"][data-kind="day"]'), (SP.products || {})[row.featured_handle] || "", link(SP.shopBase, `/products/${row.featured_handle}`, SP.utm));
      if (row.theme) setItem(list.querySelector('[data-shop="speclang"][data-kind="week"]'), (SP.collections || {})[row.theme] || "", link(SP.shopBase, `/collections/${row.theme}`, SP.utm));
    } catch { /* keep the static offer */ }
  };
  list.querySelectorAll('[data-shop="axtlan"][data-collection]').forEach(axFill);
  spFill();
  const tick = () => { const s = C.clock(C.secondsToMidnight()); bar.querySelectorAll("[data-ax-ends]").forEach((el) => { el.textContent = `${S.ends || ""} ${s}`; }); };
  tick();
  const items = [...list.children];
  let i = 0, timer = 0, countdown = 0, hovering = false, suspended = document.hidden;
  // Does every offer fit the bar on one line (the product name may keep 14 characters + ellipsis)? If not, drop parts level by level.
  const FIT = ["ax-fit-1", "ax-fit-2", "ax-fit-3"];
  const shown = (el) => !!el && el.getClientRects().length > 0;
  const px = (v) => parseFloat(v) || 0;
  const fit = () => {
    FIT.forEach((c) => bar.classList.remove(c));
    const title = bar.querySelector(".ax-dealbar__title");
    for (let level = 0; level <= FIT.length; level++) {
      if (level) bar.classList.add(FIT[level - 1]);
      const cs = getComputedStyle(bar); const gap = px(cs.columnGap);
      let avail = bar.clientWidth - px(cs.paddingInlineStart) - px(cs.paddingInlineEnd);
      [title, dots].forEach((el) => { if (shown(el)) avail -= el.getBoundingClientRect().width + gap; });
      const ok = [...list.children].every((li) => {
        const measure = !shown(li); if (measure) li.classList.add("is-measure");
        const a = li.querySelector("a"); const parts = [...a.children].filter((el) => shown(el) && !/^(absolute|fixed)$/.test(getComputedStyle(el).position));   // host overlays (axtlan.mx adds one to every link) take no room
        let need = Math.max(0, parts.length - 1) * px(getComputedStyle(a).columnGap);
        parts.forEach((p) => {
          if (!p.classList.contains("ax-dealbar__name")) { need += p.getBoundingClientRect().width; return; }
          const len = p.textContent.length; need += len > 14 ? p.scrollWidth * 14 / len : p.scrollWidth;
        });
        if (measure) li.classList.remove("is-measure");
        return need <= avail + .5;
      });
      if (ok) return;
    }
  };
  const show = (n) => {
    i = (n + items.length) % items.length;
    items.forEach((li, k) => li.classList.toggle("is-current", k === i));
    dots.querySelectorAll("button").forEach((b, k) => b.setAttribute("aria-current", String(k === i)));
  };
  const sync = () => {
    clearInterval(timer); timer = 0;
    if (suspended) { clearInterval(countdown); countdown = 0; }
    else if (!countdown) { tick(); countdown = setInterval(tick, 1000); }
    const rotating = items.length > 1 && !reduced();
    bar.classList.toggle("is-rotating", rotating);
    bar.classList.toggle("is-static", !rotating);
    dots.hidden = items.length < 2;
    show(i); fit();
    if (rotating && !suspended && !hovering && !bar.contains(document.activeElement)) timer = setInterval(() => show(i + 1), 5000);
  };
  dots.replaceChildren(...items.map((li, k) => {
    const b = document.createElement("button");
    b.type = "button";
    b.setAttribute("aria-label", `${li.querySelector(".ax-dealbar__shop").textContent} \u00b7 ${li.querySelector(".ax-dealbar__label").textContent}`);
    b.addEventListener("click", () => { show(k); sync(); });
    return b;
  }));
  bar.addEventListener("mouseenter", () => { hovering = true; sync(); });
  bar.addEventListener("mouseleave", () => { hovering = false; sync(); });
  bar.addEventListener("focusin", sync); bar.addEventListener("focusout", () => queueMicrotask(sync));
  const preferences = new MutationObserver(sync);
  [document.documentElement, document.body].forEach(el => el && preferences.observe(el, {attributes: true,
    attributeFilter: ["data-motion-allowed", "data-motion", "data-mode", "data-contrast"]}));
  motion.addEventListener("change", sync); forced.addEventListener("change", sync);
  document.addEventListener("visibilitychange", () => { suspended = document.hidden; sync(); });
  window.addEventListener("pagehide", event => {
    suspended = true; sync();
    if (!event.persisted) { preferences.disconnect(); motion.removeEventListener("change", sync); forced.removeEventListener("change", sync); }
  });
  window.addEventListener("pageshow", () => { suspended = document.hidden; sync(); });
  // fit again whenever a width can change: the window, a web font arriving late, a name filled in, the countdown text
  if (typeof ResizeObserver === "function") {
    const ro = new ResizeObserver(queueFit);
    [bar, bar.querySelector(".ax-dealbar__title"), ...items.map((li) => li.querySelector("a"))].forEach((el) => el && ro.observe(el));
  } else window.addEventListener("resize", queueFit);
  if (document.fonts) { if (document.fonts.ready) document.fonts.ready.then(queueFit); if (document.fonts.addEventListener) document.fonts.addEventListener("loadingdone", queueFit); }
  sync();
})();
